import { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { api, apiErr } from "../../lib/api";
import { fmtDateTime } from "../../lib/format";
import { toast } from "sonner";
import { Card, Label, Loading, fmtDate } from "./MeHome";

const shift = (iso, days) => { const d = new Date(iso + "T00:00:00"); d.setDate(d.getDate() + days); return d.toISOString().slice(0, 10); };

export default function MeTime() {
  const [week, setWeek] = useState(null);
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/me/time${week ? `?week=${week}` : ""}`).then((r) => setD(r.data)).catch((e) => toast.error(apiErr(e))); }, [week]);
  if (!d) return <Loading />;
  const byDate = {};
  d.entries.forEach((e) => { (byDate[e.date] = byDate[e.date] || []).push(e); });
  const days = Array.from({ length: 7 }, (_, i) => shift(d.week_start, i));
  return (
    <div className="space-y-5" data-testid="me-time">
      <div><Label>Time</Label><h1 className="text-4xl font-extrabold tracking-tight mt-2 text-slate-900">My week</h1></div>
      <Card className="flex items-center justify-between">
        <button data-testid="me-time-prev" onClick={() => setWeek(shift(d.week_start, -7))} className="h-11 w-11 rounded-full grid place-items-center bg-slate-100 hover:bg-slate-200 active:scale-95 transition-all"><ChevronLeft className="h-5 w-5" /></button>
        <div className="text-center"><div className="font-bold text-slate-900">{fmtDate(d.week_start)} – {fmtDate(d.week_end)}</div><div className="text-sm text-slate-500 mt-0.5"><span data-testid="me-time-total" className="emp-num font-extrabold text-blue-600">{d.total_hours}</span> hours recorded</div></div>
        <button data-testid="me-time-next" onClick={() => setWeek(shift(d.week_start, 7))} className="h-11 w-11 rounded-full grid place-items-center bg-slate-100 hover:bg-slate-200 active:scale-95 transition-all"><ChevronRight className="h-5 w-5" /></button>
      </Card>
      {!d.time_tracking_enabled && d.entries.length === 0 && <div className="emp-empty">Your employer doesn't track time in PostWage for your position.</div>}
      <Card className="p-0 divide-y divide-slate-100 overflow-hidden">
        {days.map((day) => {
          const es = byDate[day] || [];
          const hrs = es.reduce((s, e) => s + Number(e.hours || 0), 0);
          return (
            <div key={day} className="flex items-start justify-between gap-3 px-6 py-4" data-testid={`me-time-day-${day}`}>
              <div><div className="font-semibold text-slate-800">{new Date(day + "T00:00:00").toLocaleDateString("en-CA", { weekday: "short", month: "short", day: "numeric" })}</div>
                {es.map((e, i) => <div key={i} className="text-sm text-slate-500">{(e.code || e.earning_code || "Hours")}{e.start && e.end ? ` · ${e.start}–${e.end}` : ""}{e.approval_status ? ` · ${e.approval_status}` : ""}{e.note ? ` · ${e.note}` : ""}</div>)}
              </div>
              <div className="emp-num font-extrabold text-slate-900">{hrs ? hrs.toFixed(2) : <span className="text-slate-300">—</span>}</div>
            </div>
          );
        })}
      </Card>
      {d.punches.length > 0 && <Card><Label>Time clock punches</Label><div className="mt-3 text-sm space-y-1.5">{d.punches.map((p, i) => <div key={i} className="flex justify-between"><span className="capitalize">{p.kind || p.type}</span><span className="tabular-nums">{fmtDateTime(p.ts)}</span></div>)}</div></Card>}
      <div className="grid grid-cols-2 gap-4">
        <Card><Label>Vacation balance</Label><div className="emp-num text-2xl font-extrabold mt-1 text-slate-900">${d.vacation_balance.toFixed(2)}</div></Card>
        <Card><Label>Time off in lieu</Label><div className="emp-num text-2xl font-extrabold mt-1 text-slate-900">{d.lieu_balance.toFixed(2)} h</div></Card>
      </div>
    </div>
  );
}
